import { call } from 'redux-saga/effects';
import AuthorizedUserDTO from '../../../dto/AuthorizedUserDTO';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* authorizedRegistration(action) {
  try {
    const client = new AuthorizedUserDTO(action.payload);
    const url = `${BACKEND_URL}/auth/signup`;
    const pool = client.getRegistrationData();
    const userDataResponse = yield makeRequest(url, pool, action);
    const authorizedData = yield userDataResponse.json();

    if (userDataResponse.status === OK) {
      yield call(resolveActionPromise(action, authorizedData));
    } else {
      yield call(rejectActionPromise(action, authorizedData));
    }
  } catch (e) {
    yield processError(e);
  }
}
